import { useState } from 'react';
import { login, type LoginInput, LoginError } from '@/app/auth/services/auth.service';
import { useAuthStore } from '@/app/auth/stores/auth.store';
import { rememberLogin } from '@/app/auth/lib/remembered-login';

export const useLogin = () => {
  const setSession = useAuthStore((state) => state.setSession);
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState<LoginError | null>(null);

  const mutate = (input: LoginInput) => {
    setIsPending(true);
    setError(null);
    void (async () => {
      try {
        const session = await login(input);
        void rememberLogin(input.email, input.password);
        setSession(session);
      } catch (e) {
        setError(e instanceof LoginError ? e : new LoginError('Authentication failed'));
      } finally {
        setIsPending(false);
      }
    })();
  };

  return { mutate, isPending, isError: error !== null, error };
};
